import React, { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';
import { clinicData } from '../data';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button after user scrolls down 100px
      setIsVisible(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    window.open(`https://wa.me/91${clinicData.contact.whatsappNumber}?text=Hello, I would like to know more about your services`, '_blank');
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`
        fixed bottom-8 right-8 z-50
        bg-[#25D366] hover:bg-[#128C7E]
        text-white rounded-full shadow-lg
        w-16 h-16 flex items-center justify-center
        transition-all duration-300 ease-in-out
        transform hover:scale-110
        border-4 border-white
        ${isHovered ? 'ring-4 ring-green-300 ring-opacity-70' : ''}
      `}
      aria-label="Chat with us on WhatsApp"
    >
      <MessageCircle className="h-8 w-8" />
      <span className="sr-only">WhatsApp us</span>
    </button>
  );
};

export default WhatsAppButton;